import { useState, useEffect } from "react";
import { getSession, onSessionChange } from "../api/authApi";

// The signed-in session, or null. authLoading is true until we know which.
export default function useSession() {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    getSession().then(session => {
      setSession(session);
      setAuthLoading(false);
    });
    return onSessionChange(setSession);
  }, []);

  return { session, authLoading };
}
